import type { FormDefinition } from '../../format/form-definition';

export type EditResult = { kind: 'changed'; form: FormDefinition } | { kind: 'refused'; reason: string };

export const changed = (form: FormDefinition): EditResult => ({ kind: 'changed', form });
export const refused = (reason: string): EditResult => ({ kind: 'refused', reason });

export type EditFunctions<E extends { kind: string }> = {
  [K in E['kind']]: (form: FormDefinition, edit: Extract<E, { kind: K }>) => EditResult;
};
